import { withStyles } from "@material-ui/core";
import TextoEmNegrito from "./textoEmNegrito";
import React from "react";
import { Trans } from "adapters/i18n";

const MensagemConsumoNaoDisponivel = ({ classes }) => (
  <Trans
    i18nKey="supplementation:unavailable-consumption-message"
    components={{
      p: <p className={classes.textoCinza} />,
      b: <TextoEmNegrito />,
      i: <TextoEmNegrito style={{ fontStyle: "italic" }} />
    }}
  />
);

const styles = {
  textoCinza: {
    color: "#616161",
    fontFamily: "Roboto",
  },
};

export default withStyles(styles)(MensagemConsumoNaoDisponivel);
